import { IstanzaSezioneDati } from '@framework/api-client';
import { deserializeFormSectionsValues } from '@framework/engine';

/**
 * Restituisce i valori iniziali per i campi di una dichiarazione a partire
 * dai dati restituiti dall'API.
 */
export function getDeclarationsInitialValues(
  declarations:
    | Array<Pick<IstanzaSezioneDati, 'idSezioneDati' | 'datiJson'>>
    | undefined,
  // TODO tipizzare
  schema: any,
) {
  if (!declarations) return {};

  const initialValues = deserializeFormSectionsValues(
    schema,
    declarations.map(d => ({ idSezione: d.idSezioneDati, valori: d.datiJson })),
  );

  return initialValues;
}
